import { telemetryEventLogger } from './Telemetry.logger';

import type { TelemetryContext } from './TelemetryContext';
import type { TelemetryOrderChannel } from './TelemetryEvent.types';

export const preEventHandlers: TelemetryEventHandlers = [];

export const postEventHandlers: TelemetryEventHandlers = [
  ({ context, payload }) => {
    const orderChannelPayload = payload as TelemetryOrderChannel;
    const orderChannel = orderChannelPayload?.orderType || orderChannelPayload?.orderChannel;

    if (isValidOrderChannel(orderChannel)) {
      telemetryEventLogger.info('Setting orderChannel', orderChannel);
      context.setSuperProperty('orderChannel', orderChannel);
    }
  },
];

// ─── Helpers ─────────────────────────────────────────────────────────────────

const isValidOrderChannel = (orderChannel?: string) => {
  if (!orderChannel) return false;
  return ['pickup', 'outpost', 'delivery'].includes(orderChannel);
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type TelemetryEventHandler = (props: TelemetryEventHandlerProps) => void;

export type TelemetryEventHandlers = readonly TelemetryEventHandler[];

export type TelemetryEventHandlerProps = Readonly<{
  context: TelemetryContext;
  name: string;
  payload: unknown;
}>;
